import React, {useEffect, useRef, useState} from 'react';
import {useSelector} from "react-redux";
import Select from "react-select";
import PhotoBooth from "../../../../shared/photo_booth/photo_booth";
import PageEditor from "../../page_editor";
import RenderedHtmlContent from "../../../../shared/virtual_congress/components/rendered_html_content";


const Popup = ({close, children, htmlContent}) => {
  return <div className="modal" tabIndex="-1" role="dialog" style={{display: "block"}} onClick={close}>
    <div className="modal-dialog" role="document">
      <div className="modal-content">
        <div className="modal-header">
          {htmlContent.title && <h5 className="modal-title">{htmlContent.title}</h5>}
          <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={close}>
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          {children}
        </div>
      </div>
    </div>
  </div>
}

const RenderedHtmlContentContent = ({htmlContent}) => {
  if (htmlContent.editor_type !== 'react_page_editor') {
    return <RenderedHtmlContent identifier={htmlContent.identifier}/>
  }

  return <PageEditor
    htmlContent={htmlContent}
    readOnly={true}
  />
}

const RenderedHtmlContentPopup = ({htmlContentId, children}) => {
  const htmlContents = useSelector(state => state.htmlContents)
  const htmlContent = htmlContents.find(htmlContent => htmlContent.id === htmlContentId)

  console.log({
    htmlContentId,
    htmlContents,
    htmlContent,
  })

  const readOnly = useSelector(state => state.pageEditor?.readOnly) !== false
  const [show, setShow] = useState(false)
  const close = () => setShow(false)

  if (!htmlContent) {
    return <div className={"alert alert-danger"}>
      Html content \"{htmlContentId}\" not found.
    </div>
  }

  const open = (event) => {
    if (readOnly || event.ctrlKey) {
      setShow(true)
    }
  }

  return <>
    <div onClick={open}>
      {children}
    </div>
    {show && <Popup htmlContent={htmlContent} close={close}>
      <RenderedHtmlContentContent htmlContent={htmlContent}/>
    </Popup>}
  </>
}

const HtmlContentPopupContainerPlugin = () => {
  return {
    Renderer: (props) => {
      const {htmlContentId} = props.data
      return <RenderedHtmlContentPopup children={props.children} htmlContentId={htmlContentId}/>
    },

    id: 'html-content-popup-container-plugin',
    title: 'HTML content Popup',
    description: 'Popup containing a html content.',
    version: 1,
    controls: {
      type: 'custom',
      allowClickInside: true,
      Component: (props) => {
        const htmlContents = useSelector(state => state.htmlContents)
        const options = htmlContents.map(htmlContent => ({
          value: htmlContent.id,
          label: (htmlContent.title || htmlContent.identifier)
        }))

        return <div className="form-group">
          <label>Html Content</label>
          <Select
            defaultValue={options.find(o => o.value === props.data.htmlContentId)}
            options={options}
            menuPortalTarget={document.body}
            styles={{menuPortal: base => ({...base, zIndex: 9999})}}
            onChange={val => props.onChange({htmlContentId: val.value})}
          />
        </div>
      },
    },
  }
}

export default HtmlContentPopupContainerPlugin